/* eslint-disable */

import moment from "moment";

import { ACTION_TYPE } from '../actions/ActionTypes'
import { ENERGY_MIX_LABEL } from "../constants/Miscellaneous";
import { logWarningForDeprecatedReducer, logWarningForDeprecatedReducerWithReplacementReducer } from "../utils/deprecation";
import { enums } from "../enums";

const INITIAL_STATE = {
  currentAssetConsuming: {
    _id: undefined,
    id: undefined,
    active: true,
    organization: {},
    consumptionPercentage: null,
    cO2UsedForCertificate: 0,
    capacityWh: 0,
    maxCapacitySet: false,
    certificatesCreatedForWh: 0,
    assetID: "",
    source: "",
    sourceID: "",
    displayPercentage: 1,
    matchingPercentage: 1,
    periodNumber: null,
    periodNumber: null,
    periodType: "",
    momentTimezone: "",
    aggregationPeriodNumber: "",
    aggregationPeriodType: "",
    smireName: "",
    sourceHistory: [],
    city: "",
    country: "",
    countryLink: {},
    gpsLatitude: 0,
    gpsLongitude: 0,
    houseNumber: "",
    owner: "",
    region: "",
    street: "",
    zip: "",
    name: "",
    displayedName: "",
    maxGooContract: 0,
    maxGooContractByAsset: [],
    producingAssets: []
  },
  graphData: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartLabels: []
  },
  barChartData: {
    certificateStatusArray: [],
    data: [],
    labels: []
  },
  doughnutChartData: {
    certificateStatusArray: [],
    data: [],
    labels: []
  },
  graphDataForRangeOfficialOnly: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartDataMatched: [],
    barChartLabels: []
  },
  graphDataOnChain: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartDataMatched: [],
    barChartLabels: []
  },
  yearToDateData: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartLabels: []
  },
  yearToDateDataOnChain: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartDataMatched: [],
    barChartLabels: []
  },
  assetsConsuming: [],
  error: { message: "", isVisible: false },
  loadingConsumingMeterRead: false,
  loading: false,
  loadingYTD: false,
  refreshing: false,
  loadingOnChain: false,
  loadingYTDOnChain: false,
  refreshingOnChain: false,
  order: "asc",
  orderBy: "id",
  selected: [],
  page: 0,
  rowsPerPage: 10,
  mapHeight: 100,
  mapWidth: 100,
  dialogCo2DetailsOpen: false,
  dashboardTotalAvoidedCo2Month: null,
  dashboardTotalAvoidedCo2YTD: null,
  dashboardTotalGreenElectricityMonth: null,
  dashboardTotalGreenElectricityYTD: null,
  dashboardAverageDistanceMonth: null,
  dashboardAverageDistanceYTD: null,
  userTotalYearToDateAvoidedCO2: 0,
  consumingAssetTotalYearToDateAvoidedCO2: 0,
  officialDataForConsumingAsset: {
    totalAvoidedCO2GramsForRange: 0,
    totalAvoidedCO2GramsYearToDate: 0,
    totalEnergyMatchedInWhForRange: 0,
    totalEnergyMatchedInWhYearToDate: 0
  },
  frontEndDataForConsumingAsset: {
    totalAvoidedCO2GramsForRange: 0,
    totalAvoidedCO2GramsYearToDate: 0,
    totalEnergyMatchedInWhForRange: 0,
    totalEnergyMatchedInWhYearToDate: 0,
    averageDistanceForRangeInMeters: 0,
    averageDistanceYTDInMeters: 0,
    CO2Equivalents:[
    {co2EquivalentName: enums.CO2Equivalents.CO2_PER_TREE_SEEDING_IN_T, co2EquivalentValue: 0},
    {co2EquivalentName: enums.CO2Equivalents.NUCLEAR_WASTE_FOR_1MWH_NUCLEAR_ELECTRICITY_IN_G, co2EquivalentValue: 0},
    {co2EquivalentName: enums.CO2Equivalents.CO2_FOR_1KM_TRAVALLED_IN_G, co2EquivalentValue: 0},
    {co2EquivalentName: enums.CO2Equivalents.WORLD_TOUR_DISTANCE_IN_KM, co2EquivalentValue: 0},
    {co2EquivalentName: enums.CO2Equivalents.CO2_FOR_1KM_DRIVEN_IN_G, co2EquivalentValue: 0},
    {co2EquivalentName: enums.CO2Equivalents.AVERAGE_HOUSEHOLD_ELECTRICITY_CONSUMPTION_IN_KWH, co2EquivalentValue: 0}
  ]
  },
  producingAssetPercentageForRange: [],
  producingAssetPercentageYTD: [],
  producingAssetPercentageLastMatchedDay: [],
  doughnutDataForRange: [],
  doughnutDataYTD: [],
  doughnutDataLastMatchedDay: [],
  lastMatchedDay: "",
  oneYearButtonPressed: false, 
  thirtyDaysButtonPressed: false,
  customButtonPressed: false,
  twelveMonthsButtonPressed: false,
};

const assetsConsumingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //AssetsConsuming CRUD
    case "CREATE_ASSET_CONSUMING_START":
      logWarningForDeprecatedReducerWithReplacementReducer("CREATE_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.START_LOADING)
      return { ...state, loading: true };
      
    case "CREATE_ASSET_CONSUMING_SUCCESS":
      logWarningForDeprecatedReducerWithReplacementReducer("CREATE_ASSET_CONSUMING_SUCCESS", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING)
      return {
        ...state,
        loading: false,
        currentAssetConsuming: INITIAL_STATE.currentAssetConsuming
      };
      
    case "CREATE_ASSET_CONSUMING_FAIL":
      logWarningForDeprecatedReducerWithReplacementReducer("CREATE_ASSET_CONSUMING_FAIL", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING)
      return { ...state, loading: false };
      
    case "UPDATE_ASSET_CONSUMING_START":
      logWarningForDeprecatedReducerWithReplacementReducer("UPDATE_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.START_LOADING)
      return { ...state, loading: true };

    case "ARCHIVE_ASSET_CONSUMING_START":
      logWarningForDeprecatedReducerWithReplacementReducer("ARCHIVE_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.START_LOADING)
      return { ...state, loading: true };
      
    case "ARCHIVE_ASSET_CONSUMING_SUCCESS":
      logWarningForDeprecatedReducerWithReplacementReducer("ARCHIVE_ASSET_CONSUMING_SUCCESS", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING)
      return {
        ...state,
        loading: false,
        currentAssetProducing: {
          ...state.currentAssetConsuming,
          active: false
        }
      };
      
    case "ARCHIVE_ASSET_CONSUMING_FAIL":
      logWarningForDeprecatedReducerWithReplacementReducer("ARCHIVE_ASSET_CONSUMING_FAIL", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING)
      return { ...state, loading: false };
      
    case "RESTORE_ASSET_CONSUMING_START":
      logWarningForDeprecatedReducerWithReplacementReducer("RESTORE_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.START_LOADING)
      return { ...state, loading: true };
      
    case "RESTORE_ASSET_CONSUMING_SUCCESS":
      return {
        ...state,
        loading: false,
        currentAssetProducing: {
          ...state.currentAssetConsuming,
          active: true
        }
      };
      
    case "RESTORE_ASSET_CONSUMING_FAIL":
      return { ...state, loading: false };

    case "UPDATE_ASSET_CONSUMING_SUCCESS":
      return { ...state, loading: false };
    case "UPDATE_ASSET_CONSUMING_FAIL":
      return { ...state, loading: false };
    case "DELETE_ASSET_CONSUMING_START":
      return { ...state, loading: true };
    case "DELETE_ASSET_CONSUMING_SUCCESS":
      return { ...state, loading: false };
    case "DELETE_ASSET_CONSUMING_FAIL":
      return { ...state, loading: false };

    //AssetsConsuming data changing
    case "REORDER_ASSETS_CONSUMING_PROD_ASSETS":
      state.currentAssetConsuming.producingAssets.map(pA => {
        let currentaP = action.payload.newAssetsProducingList.find(aP => {
          return aP.id === pA.id;
        });
        return currentaP;
      });

      action.payload.assetConsuming.producingAssets.map(pA => {
        let currentaP = action.payload.newAssetsProducingList.find(aP => {
          return aP.id === pA.id;
        });
        return currentaP;
      });

      return {
        ...state,
        currentAssetConsuming: action.payload.assetConsuming
      };

    case "ADD_PROD_ASSET_TO_ASSET_CONSUMING":
      return {
        ...state,
        currentAssetConsuming: action.payload
      };

    case "REMOVE_PROD_ASSET_FROM_ASSET_CONSUMING":
      return {
        ...state,
        currentAssetConsuming: action.payload
      };

    case "CONS_ASSET_ORGANIZATION_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          organization: action.payload
        }
      };

    case "CONS_ASSET_COUNTRY_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          countryLink: action.payload
        }
      };

    case "OWNER_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          owner: action.payload
        }
      };

    case "TIME_ZONE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          momentTimezone: action.payload
        }
      };

    case "AGGREGATION_PERIOD_NUMBER_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          aggregationPeriodNumber: action.payload
        }
      };
    case "AGGREGATION_PERIOD_TYPE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          aggregationPeriodType: action.payload
        }
      };
    case "SMIRE_NAME_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          smireName: action.payload
        }
      };

    case "PRODUCING_ASSETS_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          producingAssets: action.payload
        }
      };

    // case "NAME_CONSUMING_CHANGED":
    //   return {
    //     ...state,
    //     currentAssetConsuming: {
    //       ...state.currentAssetConsuming,
    //       smireName: action.payload
    //     }
    //   };

    case "SOURCE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          source: action.payload
        }
      };
    case "ASSET_ID_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          assetID: action.payload
        }
      };

    case "SOURCE_ID_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          sourceID: action.payload
        }
      };

    case "DISPLAY_PERCENTAGE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          displayPercentage: action.payload
        }
      };
    case "MATCHING_PERCENTAGE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          matchingPercentage: action.payload
        }
      };
    case "PERIOD_NUMBER_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          periodNumber: action.payload
        }
      };
    case "PERIOD_TYPE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          periodType: action.payload
        }
      };

    case "NAME_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          name: action.payload
        }
      };

    case "DISPLAYED_NAME_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          displayedName: action.payload
        }
      };

    case "OTHER_GREEN_ATTRIBUTES_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          otherGreenAttributes: action.payload
        }
      };
    case "TYPE_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          type: action.payload
        }
      };
    case "REGISTRY_COMPLIANCE_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          registryCompliance: action.payload
        }
      };
    case "SMART_METER_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          smartMeter: action.payload
        }
      };

    case "CAPACITY_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          capacityWh: action.payload
        }
      };
    case "TYPE_OF_PUBLIC_SUPPORT_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          typeOfPublicSupport: action.payload
        }
      };
    case "OPERATIONAL_SINCE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          operationalSince: action.payload
        }
      };

    case "MAX_CAPACITY_SET_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          maxCapacitySet: action.payload
        }
      };

    case "ACTIVE_CONSUMING_CHANGED":
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          active: action.payload
        }
      };

    case "LOCATION_CONSUMING_CHANGED":
      let location = action.payload;
      return {
        ...state,
        currentAssetConsuming: {
          ...state.currentAssetConsuming,
          city: location.city,
          country: location.country,
          gpsLatitude: location.gpsLatitude,
          gpsLongitude: location.gpsLongitude,
          houseNumber: location.houseNumber,
          region: location.region,
          street: location.street,
          zip: location.zip
        }
      };

    case "GET_ASSETS_CONSUMING_START":
      return { ...state };

    case "DASHBOARD_START":
      return { ...state };

    case "DASHBOARD_SUCCESS":
      return {
        ...state,
        dashboardTotalAvoidedCo2Month:
          action.payload.dashboardTotalAvoidedCo2Month,
        dashboardTotalAvoidedCo2YTD: action.payload.dashboardTotalAvoidedCo2YTD,
        dashboardTotalGreenElectricityMonth:
          action.payload.dashboardTotalGreenElectricityMonth,
        dashboardTotalGreenElectricityYTD:
          action.payload.dashboardTotalGreenElectricityYTD,
        dashboardAverageDistanceMonth:
          action.payload.dashboardAverageDistanceMonth,
        dashboardAverageDistanceYTD: action.payload.dashboardAverageDistanceYTD,
        dashboardAveragePercentageMonthLabels:
          action.payload.dashboardAveragePercentageMonthLabels,
        dashboardAveragePercentageMonthData:
          action.payload.dashboardAveragePercentageMonthData,
        dashboardAveragePercentageLastDayLabels:
          action.payload.dashboardAveragePercentageLastDayLabels,
        dashboardAveragePercentageLastDayData:
          action.payload.dashboardAveragePercentageLastDayData,
        yearToDateAssetsData: action.payload.yearToDateAssetsData
      };
      
    case "GET_ASSETS_CONSUMING_SUCCESS":
      return { ...state, assetsConsuming: action.payload };

    case "GET_ASSET_CONSUMING_DATA_SUCCESS":
      return { ...state, graphData: action.payload };

    case "GET_GRAPH_DATA_FOR_RANGE_OFFICIAL_SUCCESS":
      return { ...state, graphDataForRangeOfficialOnly: action.payload };

    case "GET_ASSET_CONSUMING_DATA_ONCHAIN_SUCCESS":
      return {
        ...state,
        graphDataOnChain: action.payload
      };

    case "GET_ASSET_CONSUMING_BARCHARTDATA_SUCCESS":
      return {
        ...state,
        barChartData: action.payload
      };

    case "GET_ASSET_CONSUMING_DOUGHNUTCHARTDATA_SUCCESS":
      return {
        ...state,
        doughnutChartData: action.payload
      };

    case "GET_ASSET_CONSUMING_YEAR_TO_DATE_SUCCESS":
      return { ...state, yearToDateData: action.payload };

    case "GET_ASSET_CONSUMING_YEAR_TO_DATE_ONCHAIN_SUCCESS":
      return {
        ...state,
        yearToDateDataOnChain: action.payload
      };

    case "GET_ASSETS_CONSUMING_FAIL":
      logWarningForDeprecatedReducerWithReplacementReducer("GET_ASSETS_CONSUMING_FAIL", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING);      
      return { ...state };
      
    case "SORT_ASSETS_CONSUMING":
      const assetsConsuming = action.payload.assetsConsuming;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, assetsConsuming, order, orderBy };
      
    case "CHANGE_PAGE":
      const page = action.payload.page;
      return { ...state, page };
    case "CHANGE_ROWS_PER_PAGE":
      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage };
      
    case "GET_ASSET_CONSUMING_START":
      logWarningForDeprecatedReducerWithReplacementReducer("GET_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.START_LOADING);
      return {
        ...state
      };
      
    case "GET_ASSET_CONSUMING_REFRESH":
      return { ...state, refreshing: true };
      
    case "GET_ASSET_CONSUMING_SUCCESS":
      return {
        ...state,
        currentAssetConsuming: action.payload
      };
      
    case "GET_ASSET_CONSUMING_FAIL":
      logWarningForDeprecatedReducerWithReplacementReducer("GET_ASSET_CONSUMING_START", ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING);
      return { ...state };
      
    case "SAVE_CONSUMING_SMART_METER_READ_START":
      logWarningForDeprecatedReducer("SAVE_CONSUMING_SMART_METER_READ_START");
        return { ...state, loadingConsumingMeterRead: true };
    case "SAVE_CONSUMING_SMART_METER_READ_SUCCESS":
      logWarningForDeprecatedReducer("SAVE_CONSUMING_SMART_METER_READ_SUCCESS")
      return { ...state, loadingConsumingMeterRead: false };
    case "SAVE_CONSUMING_SMART_METER_READ_FAIL":
      logWarningForDeprecatedReducer("SAVE_CONSUMING_SMART_METER_READ_FAIL")
      return { ...state, loadingConsumingMeterRead: false };

    case "TOGGLE_CO2_DETAILS":
      const dialogCo2DetailsOpen = !state.dialogCo2DetailsOpen;
      return { ...state, dialogCo2DetailsOpen };

    case "RESET_ASSET_CONSUMING":
      return {
        ...state,
        currentAssetConsuming: {
          id: undefined,
          active: true,
          organization: {},
          consumptionPercentage: null,
          cO2UsedForCertificate: 0,
          capacityWh: 0,
          maxCapacitySet: false,
          certificatesCreatedForWh: 0,
          assetID: "",
          source: "",
          sourceID: "",
          displayPercentage: 1,
          matchingPercentage: 1,
          periodNumber: null,
          periodNumber: null,
          periodType: "",
          momentTimezone: "",
          aggregationPeriodNumber: "",
          aggregationPeriodType: "",
          smireName: "",
          sourceHistory: [],
          city: "",
          country: "",
          countryLink: {},
          gpsLatitude: 0,
          gpsLongitude: 0,
          houseNumber: "",
          owner: "",
          region: "",
          street: "",
          zip: "",
          name: "",
          displayedName: "",
          maxGooContract: 0,
          maxGooContractByAsset: [],
          producingAssets: []
        },
      };

    case "LOGOUT_SUCCESS":
      return INITIAL_STATE;
    

    case ACTION_TYPE.ASSET_CONSUMING.ONE_YEAR_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: true, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.TWELVE_MONTHS_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: true, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.THIRTY_DAYS_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: true,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.CUSTOM_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: true,
      };

    case ACTION_TYPE.ASSET_CONSUMING.ONE_YEAR_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: true, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.TWELVE_MONTHS_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: true, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.THIRTY_DAYS_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: true,
        customButtonPressed: false,
      };

    case ACTION_TYPE.ASSET_CONSUMING.CUSTOM_BUTTON_PRESSED:
      return { 
        ...state, 
        twelveMonthsButtonPressed: false, 
        oneYearButtonPressed: false, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: true,
      };

    case ACTION_TYPE.ASSET_CONSUMING.GET_USER_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS:
      return { ...state, userTotalYearToDateAvoidedCO2: action.payload.userTotalYearToDateAvoidedCO2 };

    case ACTION_TYPE.ASSET_CONSUMING.GET_CONSUMING_ASSET_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS:
      return { ...state, consumingAssetTotalYearToDateAvoidedCO2: action.payload.consumingAssetTotalYearToDateAvoidedCO2 };

    case ACTION_TYPE.ASSET_CONSUMING.GET_OFFICIAL_DATA_FOR_CONSUMING_ASSET:
      return { ...state, officialDataForConsumingAsset: action.payload.officialDataForConsumingAsset };
      
    case ACTION_TYPE.ASSET_CONSUMING.GET_FRONT_END_DATA_FOR_CONSUMING_ASSET:
      return { ...state, frontEndDataForConsumingAsset: action.payload.frontEndDataForConsumingAsset };

    case ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS: {
      let producingAssetPercentageForRange = action.payload;

      let doughnutDataForRange = producingAssetPercentageForRange.percentageOfMatchedEnergyArray.map(e => { return {
        label: e.producingAsset.displayedName,
        percentage: e.percentageOfMatchedEnergy
      }});

      doughnutDataForRange.push({
        label: ENERGY_MIX_LABEL,
        percentage: producingAssetPercentageForRange.percentageOfEnergyMix
      })

      return { ...state, 
        producingAssetPercentageForRange,
        doughnutDataForRange
      };
    }

    case ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS: {
      let producingAssetPercentageYTD = action.payload;

      let doughnutDataYTD = producingAssetPercentageYTD.percentageOfMatchedEnergyArray.map(e => { return {
        label: e.producingAsset.displayedName,
        percentage: e.percentageOfMatchedEnergy
      }});

      doughnutDataYTD.push({
        label: ENERGY_MIX_LABEL,
        percentage: producingAssetPercentageYTD.percentageOfEnergyMix
      })

      return { ...state, 
        producingAssetPercentageYTD,
        doughnutDataYTD
      };
    }

    case ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS: {
      let producingAssetPercentageLastMatchedDay = action.payload.percentageData;
      let lastMatchedDay = action.payload.lastMatchedDay;

      let doughnutDataLastMatchedDay = producingAssetPercentageLastMatchedDay.percentageOfMatchedEnergyArray.map(e => { return {
        label: e.producingAsset.displayedName,
        percentage: e.percentageOfMatchedEnergy
      }});

      doughnutDataLastMatchedDay.push({
        label: ENERGY_MIX_LABEL,
        percentage: producingAssetPercentageLastMatchedDay.percentageOfEnergyMix
      })

      return { ...state, 
        producingAssetPercentageLastMatchedDay,
        doughnutDataLastMatchedDay,
        lastMatchedDay
      };
    }
    
    case "START_LOADING": 
    case ACTION_TYPE.ASSET_CONSUMING.START_LOADING: 
      return { ...state, loading: true };
    
    case ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING: 
      return { ...state,
        loadingConsumingMeterRead: false,
        loading: false,
        loadingYTD: false,
        refreshing: false,
        loadingOnChain: false,
        loadingYTDOnChain: false,
        refreshingOnChain: false
      };
  
    case ACTION_TYPE.ASSET_CONSUMING.RESET_CARD_UNDERLYING_VALUES: 
      return { ...state,
        dashboardTotalAvoidedCo2Month: null,
        dashboardTotalAvoidedCo2YTD: null,
        dashboardTotalGreenElectricityMonth: null,
        dashboardTotalGreenElectricityYTD: null,
        dashboardAverageDistanceMonth: null,
        dashboardAverageDistanceYTD: null,
        userTotalYearToDateAvoidedCO2: 0,
        consumingAssetTotalYearToDateAvoidedCO2: 0,
        officialDataForConsumingAsset: {
          totalAvoidedCO2GramsForRange: 0,
          totalAvoidedCO2GramsYearToDate: 0,
          totalEnergyMatchedInWhForRange: 0,
          totalEnergyMatchedInWhYearToDate: 0
        },
        frontEndDataForConsumingAsset: {
          totalAvoidedCO2GramsForRange: 0,
          totalAvoidedCO2GramsYearToDate: 0,
          totalEnergyMatchedInWhForRange: 0,
          totalEnergyMatchedInWhYearToDate: 0,
          averageDistanceForRangeInMeters: 0,
          averageDistanceYTDInMeters: 0
        },
      };
    
    case ACTION_TYPE.ASSET_CONSUMING.RESET_GRAPH_DATA: 
      return INITIAL_STATE;
      return { ...state,

        currentAssetConsuming: {
          _id: undefined,
          id: undefined,
          active: true,
          organization: {},
          consumptionPercentage: null,
          cO2UsedForCertificate: 0,
          capacityWh: 0,
          maxCapacitySet: false,
          certificatesCreatedForWh: 0,
          assetID: "",
          source: "",
          sourceID: "",
          displayPercentage: 1,
          matchingPercentage: 1,
          periodNumber: null,
          periodNumber: null,
          periodType: "",
          momentTimezone: "",
          aggregationPeriodNumber: "",
          aggregationPeriodType: "",
          smireName: "",
          sourceHistory: [],
          city: "",
          country: "",
          countryLink: {},
          gpsLatitude: 0,
          gpsLongitude: 0,
          houseNumber: "",
          owner: "",
          region: "",
          street: "",
          zip: "",
          name: "",
          displayedName: "",
          maxGooContract: 0,
          maxGooContractByAsset: [],
          producingAssets: []
        },
        graphData: {
          doughnutChartLabels: [],
          doughnutChartData: [],
          doughnutChartLastDayData: [],
          doughnutData: [],
          barChartData: [],
          barChartLabels: []
        },
        graphDataForRangeOfficialOnly: {
          doughnutChartLabels: [],
          doughnutChartData: [],
          doughnutChartLastDayData: [],
          doughnutData: [],
          barChartData: [],
          barChartDataMatched: [],
          barChartLabels: []
        },
        graphDataOnChain: {
          doughnutChartLabels: [],
          doughnutChartData: [],
          doughnutChartLastDayData: [],
          doughnutData: [],
          barChartData: [],
          barChartDataMatched: [],
          barChartLabels: []
        },
        yearToDateData: {
          doughnutChartLabels: [],
          doughnutChartData: [],
          doughnutChartLastDayData: [],
          doughnutData: [],
          barChartData: [],
          barChartLabels: []
        },
        yearToDateDataOnChain: {
          doughnutChartLabels: [],
          doughnutChartData: [],
          doughnutChartLastDayData: [],
          doughnutData: [],
          barChartData: [],
          barChartDataMatched: [],
          barChartLabels: []
        },
        barChartData: {
          certificateStatusArray: [],
          data: [],
          labels: []
        },
        doughnutChartData: {
          certificateStatusArray: [],
          data: [],
          labels: []
        },
      };

    default:
      return state;
  }
};

export default assetsConsumingReducer;



// WEBPACK FOOTER //
// ./src/reducers/assetsConsumingReducer.js